import * as Scrivito from "scrivito"
import { collectRows } from "scrivito/cmsExport/collectRows"
import { downloadCsv, generateCsv } from "scrivito/cmsExport/generateCsv"
import { raiseToast } from "shared/lib/toast/raiseToast"
import { ToastType } from "shared/types/Toast"

import I18n from "i18next"

function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

async function runCmsExport() {
  const toastId = raiseToast({
    type: ToastType.LOADING,
    message: I18n.t("editing:CmsExport.loading"),
    autoClose: false
  })
  try {
    const rows = await collectRows()
    const csv = generateCsv(rows)
    downloadCsv(csv, `cms-export-${todayIso()}.csv`)
    raiseToast({
      id: toastId as string,
      type: ToastType.SUCCESS,
      message: I18n.t("editing:CmsExport.success"),
      autoClose: 4000
    })
  } catch {
    raiseToast({
      id: toastId as string,
      type: ToastType.ERROR,
      message: I18n.t("editing:CmsExport.failure"),
      autoClose: 4000
    })
  }
}

export function configureMenu() {
  Scrivito.extendMenu(menu => {
    menu.insert({
      id: "cmsExport",
      title: I18n.t("editing:CmsExport.menuTitle"),
      onClick: () => runCmsExport(),
      position: { after: "system.openPageDetails" },
      group: "system.details"
    })

    menu.insert({
      id: "cmsImport",
      title: I18n.t("editing:CmsImport.menuTitle"),
      onClick: () =>
        Scrivito.openDialog(I18n.t("editing:CmsImport.dialogTitle")),
      position: { after: "cmsExport" },
      group: "system.details"
    })
  })
}
